module.exports = __webpack_public_path__ + "img/Recubre_Estuco Premium.ca16a253.png";